import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class ScreenTypeService {
  isMobileScreen(): boolean {
    return window.innerWidth <= 767;
  }

  isTabletScreen(): boolean {
    return window.innerWidth <= 979;
  }

  isLargeScreen(): boolean {
    return window.innerWidth <= 1180;
  }

  isVeryLargeScreen(): boolean {
    return window.innerWidth > 1599;
  }
}
